// @flow
import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as campaignsCreators from '../../actions/campaigns/campaignCreators';
import {
  getInsightSets,
  updateCurrentInsightSet,
  getInsightSetInsights
} from '../../actions/insightSets/insightSetCreators';
import {
  getCurrentOrganisationInsightSets,
  getCurrentOrganisationShapeSets,
  setCurrentOrganisationOrLocation
} from '../../actions/organisations/organisationCreators';
import { getSetting } from '../../actions/settings/settingsCreators';
import { Grid, Row, Col } from 'react-bootstrap';
import { Helmet } from 'react-helmet';
import CampaignSidebar from './CampaignSidebar';
import CampaignDetails from './CampaignDetails';
import CampaignHeader from '../../components/CampaignHeader';
import LoadingSpinner from '../../components/LoadingSpinner';
import type { Dispatch } from 'redux';

type Params = {
  context: string,
  organisationId: number,
  campaignId: string | number
};

type Props = {
  params: Params,
  router: any,
  currentOrganisation: Object,
  currentLocation: Object,
  currentCampaign: Object,
  settings: Object,
  campaigns: any,
  setCurrentOrganisationOrLocation: (o: number, c: string, s?: boolean) => void,
  updateCurrentCampaign: (c: number, o: number) => Promise<*>,
  updateCampaign: (c: Object, context: string, r: boolean) => void,
  getSetting: (s: string) => void,
  cloneCampaign: Function,
  addCampaign: Function,
  getInsightSetInsights: Function,
  getCampaignSettings: Function,
  getCurrentOrganisationShapeSets: Function,
  getCurrentOrganisationInsightSets: Function,
  canSendToDoNotMail: boolean
};

type State = {
  loading: boolean,
  currentStep: number
};

class Campaigns extends React.Component<Props, State> {
  intervalId: any;

  constructor(props: Props) {
    super(props);
    this.state = {
      loading: true,
      currentStep: 1
    };
  }

  componentDidMount() {
    const {
      params: { context, organisationId, campaignId },
      setCurrentOrganisationOrLocation,
      updateCurrentCampaign,
      getSetting
    } = this.props;

    getSetting('campaignHelpPdf');
    getSetting('campaignHelpVideo');
    this.pollLocalStorage();
    // Load currentOrganisation/currentLocation,
    if (
      this.props &&
      this.props.params &&
      this.props.params.context !== 'global'
    ) {
      setCurrentOrganisationOrLocation(parseInt(organisationId, 10), context);
    }

    // Load currentCampaign
    updateCurrentCampaign(
      parseInt(campaignId, 10),
      organisationId ? parseInt(organisationId, 10) : 0
    ).then(success => {
      this.setState({ loading: false });
    });
  }

  componentWillUnmount() {
    clearInterval(this.intervalId);
  }

  componentWillReceiveProps(nextProps) {
    this.handleCurrentOrgChange(nextProps);
    this.handleCurrentLocationChange(nextProps);
    this.handleCampaignIdUpdate(nextProps);
  }

  handleCurrentOrgChange = nextProps => {
    const {
      router,
      params: { context }
    } = this.props;

    const newUrlId = nextProps.params.organisationId;
    const currentOrgId = this.props.currentOrganisation.id;
    const newCurrentOrgId = nextProps.currentOrganisation.id;

    // state org has changed to something other than the new urlId
    const currentOrgHasChanged =
      currentOrgId !== newCurrentOrgId &&
      newCurrentOrgId !== parseInt(newUrlId, 10);

    if (currentOrgHasChanged) {
      if (context === 'sub-account') {
        // redirect to dashboard
        router.push('/');
      } else {
        // update url back to /campaigns
        router.push(`/customer/${newCurrentOrgId}/campaigns`);
      }
      setCurrentOrganisationOrLocation(newCurrentOrgId, context);
    }
  };

  handleCurrentLocationChange = nextProps => {
    // Update campaigns if currentLocation has changed
    const newCurrentLocation = nextProps.currentLocation;
    const currentLocation = this.props.currentLocation;
    const context = this.props.params.context;
    if (currentLocation.id !== newCurrentLocation.id) {
      if (context === 'sub-account') {
        // if context is location, redirect to /campaigns page
        this.props.router.push(
          `/sub-account/${newCurrentLocation.id}/campaigns`
        );
      }
      setCurrentOrganisationOrLocation(newCurrentLocation.id, context);
    }
    // if context is customer, do nothing
  };

  handleCampaignIdUpdate = nextProps => {
    const campaignId = this.props.params.campaignId;
    let newCampaignId = nextProps.params.campaignId;

    // campaign Id in URL has changed
    if (newCampaignId !== campaignId) {
      const currentOrgId = this.currentOrgId();
      newCampaignId = parseInt(newCampaignId, 10);
      this.setState({ loading: true });
      this.props
        .updateCurrentCampaign(newCampaignId, currentOrgId)
        .then(success => this.setState({ loading: false }));
    }
  };

  currentOrgId = () => parseInt(this.props.params.organisationId, 10);

  cloneCampaign = campaign => {
    const { organisationId, context } = this.props.params;
    campaign &&
      campaign.id &&
      this.props.cloneCampaign(
        parseInt(campaign.id, 10),
        parseInt(organisationId, 10),
        context
      );
  };

  updateCampaign = desiredStep => {
    const updatedCampaign = {
      ...this.props.currentCampaign,
      statusTypeId: desiredStep
    };
    const redirect = true;

    this.props.updateCampaign(
      updatedCampaign,
      this.props.params.context,
      redirect
    );
  };

  pollLocalStorage = () => {
    this.intervalId = setInterval(() => {
      const currentCampaignRaw = localStorage.getItem(
        'reduxPersist:currentCampaign'
      );
      let currentCampaign;
      if (currentCampaignRaw) {
        currentCampaign = JSON.parse(currentCampaignRaw);
      }
      let currentStep;
      if (currentCampaign) {
        currentStep = currentCampaign.statusTypeId;
      }
      if (this.state.currentStep !== currentStep) {
        this.setState({ currentStep });
      }
    }, 1000);
  };

  render() {
    const { settings, currentOrganisation, params, isGlobal } = this.props;
    var currentCampaign =
      this.props.campaigns &&
      this.props.campaigns.filter(
        campaign => campaign.id === parseInt(this.props.params.campaignId, 10)
      ).length === 1
        ? this.props.campaigns.filter(
            campaign =>
              campaign.id === parseInt(this.props.params.campaignId, 10)
          )[0]
        : undefined;
    return (
      <Grid fluid>
        <Helmet>
          {params && !params.campaignId && (
            <title>
              Manage Campaigns |{' '}
              {currentOrganisation && currentOrganisation.name
                ? currentOrganisation.name + ' | '
                : ''}{' '}
              Campaign Targeter
            </title>
          )}
          {this.props.params.context !== 'global' && params.campaignId && (
            <title>
              Edit Campaign | {currentOrganisation.name} | Campaign Targeter
            </title>
          )}
          {this.props.params.context == 'global' && (
            <title>View Campaign | Campaign Targeter</title>
          )}
        </Helmet>
        <Row>
          <CampaignHeader
            params={this.props.params}
            currentStep={1}
            campaignStatus={this.props.currentCampaign.statusTypeId || 1}
            pdfUrl={
              settings && settings.campaignHelpPdf
                ? settings.campaignHelpPdf.value
                : ''
            }
            videoUrl={
              settings && settings.campaignHelpVideo
                ? settings.campaignHelpVideo.value
                : ''
            }
            campaignIsLocked={
              currentCampaign && currentCampaign.isLocked ? true : false
            }
            isGlobal={this.props.params.context === 'global'}
          />
        </Row>
        <Row>
          <Col sm={3} className="sidebar-wrapper">
            {/* $FlowFixMe */}
            <CampaignSidebar
              {...this.props}
              currentOrgId={this.props.params.organisationId}
              cloneCampaign={this.cloneCampaign}
              isGlobal={this.props.params.context === 'global'}
            />
          </Col>
          <Col sm={9} className="generic-main-content-wrapper">
            <div className="main-content">
              {this.state.loading && <LoadingSpinner />}
              {!this.state.loading && (
                <CampaignDetails
                  {...this.props}
                  cloneCampaign={this.cloneCampaign}
                  canSendToDoNotMail={this.props.canSendToDoNotMail}
                  isGlobal={this.props.params.context === 'global'}
                />
              )}
            </div>
          </Col>
        </Row>
      </Grid>
    );
  }
}

function mapStateToProps(state) {
  return {
    campaigns: state.campaigns,
    currentCampaign: state.currentCampaign,
    currentOrganisation: state.currentOrganisation,
    currentInsightSet: state.currentInsightSet,
    currentLocation: state.currentLocation,
    settings: state.settings,
    canSendToDoNotMail: state.currentOrganisation.canSendToDoNotMail
  };
}

function mapDispatchToProps(dispatch: Dispatch<*>) {
  return bindActionCreators(
    {
      ...campaignsCreators,
      getInsightSets,
      getInsightSetInsights,
      getCurrentOrganisationInsightSets,
      getCurrentOrganisationShapeSets,
      updateCurrentInsightSet,
      setCurrentOrganisationOrLocation,
      getSetting
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(Campaigns);



// WEBPACK FOOTER //
// ./src/containers/campaigns/Campaigns.js